import React from "react";
import { Users, CircleUserRound } from "lucide-react";

const OPTS = [
  { id: "internal", title: "DISPO INTERNA", sub: "Nostro autista", Icon: CircleUserRound },
  { id: "external", title: "DISPO ESTERNA", sub: "Fornitore", Icon: Users },
];

export function DispoModeToggle({ mode, onChange }) {
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="dispo-mode-toggle">
      {OPTS.map(({ id, title, sub, Icon }) => {
        const on = mode === id;
        return (
          <button key={id} type="button" onClick={() => onChange(id)} data-testid={`dispo-mode-${id}`} aria-pressed={on}
            className={`flex items-center gap-3 rounded-xl border px-4 py-3 text-left transition-colors ${on ? "border-amber-400 bg-gradient-to-r from-amber-200 to-amber-500 text-slate-950" : "border-slate-800 bg-slate-950/60 text-slate-300 hover:border-amber-500/50"}`}>
            <Icon size={26} className="shrink-0" />
            <span className="flex flex-col leading-tight">
              <span className="text-sm font-bold tracking-wide">{title}</span>
              <span className={`text-[11px] ${on ? "text-slate-800" : "text-slate-500"}`}>{sub}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
